import {
  obterConfiguracaoAdd,
  obterConfiguracaoBase,
  obterConfiguracaoDeletar,
  ObterConfiguracaoEditar,
} from "./configuracao-tabela-base";

export function obterConfiguracaoTelefones(tiposTelefones) {
  let configuracaoTelefones = _obterConfiguracaoTelefonesBase();

  configuracaoTelefones.columns = {
    tipoTelefone: _obterColunaTipoTelefone(tiposTelefones),
    numero: { title: "Número", filter: false },
    ramal: { title: "Ramal", filter: false },
    contato: { title: "Contato", filter: false },
    email: { title: "Email", filter: false },
    departamento: { title: "Departamento", filter: false },
  };

  return configuracaoTelefones;
}

export function obterConfiguracaoTelefonesDevedor(tiposTelefones) {
  let configuracaoTelefonesDevedor = _obterConfiguracaoTelefonesBase();

  configuracaoTelefonesDevedor.columns = {
    tipoTelefone: _obterColunaTipoTelefone(tiposTelefones),
    numero: { title: "Número", filter: false },
    ramal: { title: "Ramal", filter: false },
    contato: { title: "Contato", filter: false },
  };
}

function _obterConfiguracaoTelefonesBase() {
  const base = obterConfiguracaoBase();

  return {
    ...base,
    add: obterConfiguracaoAdd(),
    edit: ObterConfiguracaoEditar(),
    delete: obterConfiguracaoDeletar(),
    columns: {},
  };
}

function _obterColunaTipoTelefone(tiposTelefones) {
  const edicaoAbaTelefone = {
    type: "list",
    config: { selectText: "Selecione...", list: tiposTelefones },
  };
  
  const colunaTipoTelefone = {
    title: "Tipo Telefone",
    editor: edicaoAbaTelefone,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };
  return colunaTipoTelefone;
}
